import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { CuttingTypeDocument, cuttingTypePullQueryBuilder } from './queryBuilder';

export function cuttingTypeFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<CuttingTypeDocument> {
  const syncConfig = configBuilder<CuttingTypeDocument>(RxdbCollectionNameV2.CUTTING_TYPE);
  doNotAutoSync(syncConfig);

  pull(syncConfig, cuttingTypePullQueryBuilder);

  const replicationState = replicate(syncConfig);
  // Legacy had the syncInterval set to LiveInterval.MINUTES_30.
  return create(RxdbCollectionNameV2.CUTTING_TYPE, replicationState, [sites]);
}
